// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BooksContent_booksContainer__oJy4X {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  padding: 16px;
}

.BooksContent_header__pZlLM {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}

.BooksContent_header__pZlLM h1 {
  margin: 0;
  color: white;
}

.BooksContent_buttonGroup__GieBW {
  display: flex;
  gap: 10px;
}

.BooksContent_addButton__9yV4o {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #ff3333;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}

.BooksContent_addButton__9yV4o:hover {
  background-color: #ff5252;
  transform: translateY(-2px);
}

.BooksContent_bookItem__Zrr53 {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background-color: transparent;
  transition: transform 0.2s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.BooksContent_bookItem__Zrr53:hover {
  transform: scale(1.02);
}

.BooksContent_bookImage__FvtgI {
  width: 100%;
  object-fit: cover;
  display: block;
}

.BooksContent_bookTitle__if683 {
  padding: 12px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.BooksContent_bookGenre__9ui70 {
  font-size: 12px;
  background-color: rgba(255, 51, 51, 0.8);
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: normal;
}

.BooksContent_iconsOverlay__2zUm3 {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.BooksContent_bookItem__Zrr53:hover .BooksContent_iconsOverlay__2zUm3 {
  opacity: 1;
  color: #E50914;
}

.BooksContent_icon__oZvUX {
  background: rgba(255, 255, 255, 0.8);
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s ease;
}

.BooksContent_icon__oZvUX:hover {
  background: rgba(255, 255, 255, 1);
}

/* Pagination styles */
.BooksContent_pagination__xNbWu {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  padding: 10px;
}

.BooksContent_paginationButton__VryiU {
  background-color: #E50914;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.BooksContent_paginationButton__VryiU:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

.BooksContent_paginationButton__VryiU:hover:not(:disabled) {
  background-color: #b00710;
}

.BooksContent_pageInfo__UJnP- {
  font-weight: 600;
  color: #fff;
  font-size: 14px;
}

/* Modal styles */
.BooksContent_modalOverlay__tpiKb {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.BooksContent_modalContent__hMXEF {
  background-color: #18181B;
  padding: 20px;
  border: 2px solid #E50914;
  border-radius: 8px;
  text-align: center;
  max-width: 300px;
  width: 90%;
  color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.BooksContent_modalButtons__cLLbF {
  margin-top: 16px;
  display: flex;
  justify-content: space-around;
}

.BooksContent_modalButton__tJlw2 {
  background-color: #E50914;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.BooksContent_modalButton__tJlw2:hover {
  background-color: #b00710;
}

.BooksContent_modalButton__tJlw2:disabled {
  background-color: #aaa;
  cursor: not-allowed;
}

/* Loading state */
.BooksContent_loading__OIaTw {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

/* Empty state */
.BooksContent_empty__HT3I7 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  color: white;
  gap: 16px;
}

/* No results state */
.BooksContent_noResults__61-4Z {
  text-align: center;
  padding: 40px;
  color: #fff;
  font-size: 18px;
}

/* Search Bar */
.BooksContent_searchContainer__2s-dJ {
  display: flex;
  align-items: center;
  background: #f1f1f124;
  padding: 8px 12px;
  border-radius: 6px;
  width: 250px;
}

.BooksContent_searchIcon__G6Yop {
  color: #aaa;
}

.BooksContent_searchInput__4Eh4O {
  border: none;
  background: transparent;
  padding: 5px;
  outline: none;
  flex: 1 1;
  font-size: 14px;
  color: white;
}

.BooksContent_searchInput__4Eh4O::placeholder {
  color: #aaa;
}

/* Responsive styles */
@media (min-width: 769px) and (max-width: 1024px) {
  .BooksContent_booksContainer__oJy4X {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 481px) and (max-width: 768px) {
  .BooksContent_booksContainer__oJy4X {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .BooksContent_header__pZlLM {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .BooksContent_buttonGroup__GieBW {
    width: 100%;
    justify-content: space-between;
  }
  
  .BooksContent_searchContainer__2s-dJ {
    width: 100%;
    max-width: 100%;
  }
}

@media (max-width: 480px) {
  .BooksContent_booksContainer__oJy4X {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    padding: 8px;
  }
  
  .BooksContent_header__pZlLM {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
  }
  
  .BooksContent_buttonGroup__GieBW {
    flex-direction: column;
    width: 100%;
  }
  
  .BooksContent_addButton__9yV4o {
    width: 100%;
    margin-top: 8px;
  }
  
  .BooksContent_searchContainer__2s-dJ {
    width: 100%;
    margin-bottom: 8px;
  }
  
  /* On mobile, always show the icons (no hover needed) */
  .BooksContent_iconsOverlay__2zUm3 {
    opacity: 1;
    flex-direction: row;
    top: 4px;
    right: 4px;
  }
  
  /* Remove hover effects on mobile */
  .BooksContent_bookItem__Zrr53:hover {
    transform: none;
  }
  
  .BooksContent_bookTitle__if683 {
    font-size: 12px;
    padding: 8px;
  }
  
  .BooksContent_icon__oZvUX {
    padding: 4px;
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/content/CSS/BooksContent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,SAAO;EACP,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA,uDAAuD;EACvD;IACE,UAAU;IACV,mBAAmB;IACnB,QAAQ;IACR,UAAU;EACZ;;EAEA,mCAAmC;EACnC;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".booksContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n  padding: 16px;\n}\n\n.header {\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.header h1 {\n  margin: 0;\n  color: white;\n}\n\n.buttonGroup {\n  display: flex;\n  gap: 10px;\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #ff3333;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 10px 20px;\n  font-weight: 500;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n}\n\n.addButton:hover {\n  background-color: #ff5252;\n  transform: translateY(-2px);\n}\n\n.bookItem {\n  position: relative;\n  border-radius: 8px;\n  overflow: hidden;\n  background-color: transparent;\n  transition: transform 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.bookItem:hover {\n  transform: scale(1.02);\n}\n\n.bookImage {\n  width: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.bookTitle {\n  padding: 12px;\n  background-color: rgba(0, 0, 0, 0.7);\n  color: white;\n  font-weight: 500;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.bookGenre {\n  font-size: 12px;\n  background-color: rgba(255, 51, 51, 0.8);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: normal;\n}\n\n.iconsOverlay {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  opacity: 0;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.bookItem:hover .iconsOverlay {\n  opacity: 1;\n  color: #E50914;\n}\n\n.icon {\n  background: rgba(255, 255, 255, 0.8);\n  padding: 6px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.icon:hover {\n  background: rgba(255, 255, 255, 1);\n}\n\n/* Pagination styles */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  margin: 16px 0;\n  padding: 10px;\n}\n\n.paginationButton {\n  background-color: #E50914;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.paginationButton:disabled {\n  background-color: #aaa;\n  cursor: not-allowed;\n}\n\n.paginationButton:hover:not(:disabled) {\n  background-color: #b00710;\n}\n\n.pageInfo {\n  font-weight: 600;\n  color: #fff;\n  font-size: 14px;\n}\n\n/* Modal styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background-color: #18181B;\n  padding: 20px;\n  border: 2px solid #E50914;\n  border-radius: 8px;\n  text-align: center;\n  max-width: 300px;\n  width: 90%;\n  color: #fff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.modalButtons {\n  margin-top: 16px;\n  display: flex;\n  justify-content: space-around;\n}\n\n.modalButton {\n  background-color: #E50914;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.modalButton:hover {\n  background-color: #b00710;\n}\n\n.modalButton:disabled {\n  background-color: #aaa;\n  cursor: not-allowed;\n}\n\n/* Loading state */\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n/* Empty state */\n.empty {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  color: white;\n  gap: 16px;\n}\n\n/* No results state */\n.noResults {\n  text-align: center;\n  padding: 40px;\n  color: #fff;\n  font-size: 18px;\n}\n\n/* Search Bar */\n.searchContainer {\n  display: flex;\n  align-items: center;\n  background: #f1f1f124;\n  padding: 8px 12px;\n  border-radius: 6px;\n  width: 250px;\n}\n\n.searchIcon {\n  color: #aaa;\n}\n\n.searchInput {\n  border: none;\n  background: transparent;\n  padding: 5px;\n  outline: none;\n  flex: 1;\n  font-size: 14px;\n  color: white;\n}\n\n.searchInput::placeholder {\n  color: #aaa;\n}\n\n/* Responsive styles */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .booksContainer {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (min-width: 481px) and (max-width: 768px) {\n  .booksContainer {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  \n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .buttonGroup {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .searchContainer {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .booksContainer {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n    padding: 8px;\n  }\n  \n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 10px;\n  }\n  \n  .buttonGroup {\n    flex-direction: column;\n    width: 100%;\n  }\n  \n  .addButton {\n    width: 100%;\n    margin-top: 8px;\n  }\n  \n  .searchContainer {\n    width: 100%;\n    margin-bottom: 8px;\n  }\n  \n  /* On mobile, always show the icons (no hover needed) */\n  .iconsOverlay {\n    opacity: 1;\n    flex-direction: row;\n    top: 4px;\n    right: 4px;\n  }\n  \n  /* Remove hover effects on mobile */\n  .bookItem:hover {\n    transform: none;\n  }\n  \n  .bookTitle {\n    font-size: 12px;\n    padding: 8px;\n  }\n  \n  .icon {\n    padding: 4px;\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"booksContainer": `BooksContent_booksContainer__oJy4X`,
	"header": `BooksContent_header__pZlLM`,
	"buttonGroup": `BooksContent_buttonGroup__GieBW`,
	"addButton": `BooksContent_addButton__9yV4o`,
	"bookItem": `BooksContent_bookItem__Zrr53`,
	"bookImage": `BooksContent_bookImage__FvtgI`,
	"bookTitle": `BooksContent_bookTitle__if683`,
	"bookGenre": `BooksContent_bookGenre__9ui70`,
	"iconsOverlay": `BooksContent_iconsOverlay__2zUm3`,
	"icon": `BooksContent_icon__oZvUX`,
	"pagination": `BooksContent_pagination__xNbWu`,
	"paginationButton": `BooksContent_paginationButton__VryiU`,
	"pageInfo": `BooksContent_pageInfo__UJnP-`,
	"modalOverlay": `BooksContent_modalOverlay__tpiKb`,
	"modalContent": `BooksContent_modalContent__hMXEF`,
	"modalButtons": `BooksContent_modalButtons__cLLbF`,
	"modalButton": `BooksContent_modalButton__tJlw2`,
	"loading": `BooksContent_loading__OIaTw`,
	"empty": `BooksContent_empty__HT3I7`,
	"noResults": `BooksContent_noResults__61-4Z`,
	"searchContainer": `BooksContent_searchContainer__2s-dJ`,
	"searchIcon": `BooksContent_searchIcon__G6Yop`,
	"searchInput": `BooksContent_searchInput__4Eh4O`
};
export default ___CSS_LOADER_EXPORT___;
